import React, { useEffect, useState } from 'react'

import NavbarComponent from '../NavBar/NavbarComponent';
import HomeContent from './HomeContent';
import { useNavigate } from "react-router-dom"
import useAuth from '../hooks/useAuth';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import useLogout from '../hooks/useLogout';
import './Home.css';


function Home({ currentUserData }) {
  const [loading, setLoading] = useState(false)

  return (
    <>
      <div id="app" class="app app-content-full-height">
        <div class="card mb-3">
          <div class="hljs-container border-0 rounded">
            <div class="row">
              <div class="col-lg-8 col-md-8 col-sm-12 mx-auto">
                <div class="menu-profile-image d-flex justify-content-center align-items-center">
                  <div class="menu-profile-img bg-secondary-subtle text-secondary rounded-circle overflow-hidden">
                    <img
                      src={currentUserData.image}
                      width={100}
                      height={100}
                    />
                  </div>
                </div>
                <div class="table-responsive" style={{ marginTop: 30 }}>
                  <table class="table table-bordered">
                    <tbody>
                      <tr>
                        <th className="table-active">이름</th>
                        <td>{currentUserData.user_name}</td>
                      </tr>
                      <tr>
                        <th className="table-active">이메일</th>
                        <td>{currentUserData.email}</td>
                      </tr>
                      <tr>
                        <th className="table-active">사번</th>
                        <td>{currentUserData.empno}</td>
                      </tr>
                      <tr>
                        <th className="table-active">부서</th>
                        <td>{currentUserData.company_name}</td>
                      </tr>
                      <tr>
                        <th className="table-active">직책</th>
                        <td>{currentUserData.org_name}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
